import React from 'react';
import Talent from './Talent';
import styles from './styles.module.css';

type Item = {
  _key: string;
  name?: string;
  role?: string;
  description?: Record<string, unknown>[];
  photo?: Record<string, unknown>;
  bgColor?: {
    hex: string;
  };
  textColor?: {
    hex: string;
  };
  alignment?: string;
};

interface TalentsProps {
  heading?: string;
  alignment?: string;
  bgColor?: string;
  textColor?: string;
  items?: Item[];
}

const Talents: React.FC<TalentsProps> = ({ heading, alignment = 'left', bgColor, textColor, items }) => {
  return (
    <section
      className={styles.talents}
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      <div className={styles[alignment]}>
        <h2 className={styles.heading}>{heading}</h2>
      </div>
      <div className={styles.talentsList}>
        {items.length > 0
          ? items.map((item) => (
              <Talent
                key={item._key}
                name={item.name}
                role={item.role}
                description={item.description}
                alignment={item.alignment}
                photo={item.photo}
              />
            ))
          : null}
      </div>
    </section>
  );
};

export default Talents;
